import { useDynamicFormStore } from "@stores/dynamicFormStore";
import { Input } from "antd";
import classNames from "classnames";
import { debounce, isEmpty } from "lodash";
import React, { useEffect, useState } from "react";

const NumberInputField = (props: {
  className: any;
  value: any;
  validations: any;
  onBlur?: (arg0: string) => void;
  title: string;
  isRequired: any;
  isEditable: any;
  placeholder: any;
  handleRulesOnValueChange: any;
}) => {
  const [value, setValue] = useState("");
  const [validField, setValidField] = useState(true);

  const [setIsInvalidFlag] = useDynamicFormStore((state) => [state.setIsInvalidFlag]);

  const { minLength, maxLength, fixedLength } = props.validations;
  const _maxLength = maxLength ? maxLength : fixedLength ? fixedLength : 100;
  const _minLength = minLength ? minLength : fixedLength ? fixedLength : 0;

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value: inputValue } = e.target;
    const reg = /^-?\d*(\.\d*)?$/;
    if (reg.test(inputValue) || inputValue === "" || inputValue === "-") {
      setValue(inputValue);
      props.handleRulesOnValueChange(inputValue);
      handleBlur(inputValue);
    }
  };

  // // '.' at the end or only '-' in the input box.
  // const handleBlur = () => {
  //   let valueTemp = value;
  //   if (value.charAt(value.length - 1) === '.' || value === '-') {
  //     valueTemp = value.slice(0, -1);
  //   }
  //   setValue(valueTemp.replace(/0*(\d+)/, '$1'));
  // };

  const handleBlur = debounce((_value: string) => {
    console.log("handleBlur", _value, _value.length, _minLength, _maxLength);

    if (!isEmpty(_value)) {
      if (_value?.trim().length >= _minLength && _value?.trim().length <= _maxLength) {
        setValidField(true);
        setIsInvalidFlag(false);
      } else {
        setIsInvalidFlag(true);
        setValidField(false);
      }
    } else {
      setValidField(true);
      setIsInvalidFlag(false);
    }
  }, 1000);

  const inputClassName = classNames(`${props.className}__input`, {
    [`${props.className}__input--red-border`]: !validField,
  });

  const validationMessage = _minLength === _maxLength ? `Please match the fixed length of ${_maxLength} characters.` : "Please enter correct input";

  return (
    <>
      <Input
        minLength={_minLength}
        onChange={handleChange}
        // onBlur={handleBlur}
        placeholder={`${props.placeholder} ( Numbers Only )` }
        value={value}
        disabled={!props.isEditable}
        maxLength={_maxLength}
        className={inputClassName}
        size="large"
      />

      {!validField && <h5 className="clr-e100">{validationMessage || "Please enter correct input"}</h5>}
    </>
  );
};

export default NumberInputField;
